import { createAsyncThunk } from "@reduxjs/toolkit";
import { post, get, put, del } from "../../helpers/api_helper";
import slice from "./slice";
import * as URL from "../../helpers/url_helper";
import { toast } from "react-toastify";

export const getSystemAccess = createAsyncThunk(
  "getSystemAccess",
  async ({ data, callback }, Thunk) => {
    try {
      const queryParams = new URLSearchParams(data).toString();
      const url = `${URL.GET_SYSTEM}?${queryParams}`;
      let response = await get(url);
      callback && callback(null, response.data);
      return response;
    } catch (error) {
      console.log(error, "error");
      return Thunk.rejectWithValue(error);
    }
  }
);

export const AddSystemAccess = createAsyncThunk(
  "AddSystemAccess",
  async ({ data, callback }, Thunk) => {
    try {
      let response = await post(URL.ADD_ACCESS, data);
      callback && callback(null, response);
      return response;
    } catch (error) {
      callback && callback(error?.data?.message || error.message || error);
      return Thunk.rejectWithValue(error);
    }
  }
);

export const EditSystemAccess = createAsyncThunk(
  "EditSystemAccess",
  async ({ data, callback }, Thunk) => {
    try {
      let response = await put(URL.EDIT_ACCESS + data?._id, data);
      callback && callback(null, response);
      return response;
    } catch (error) {
      callback && callback(error.message, null);
      return Thunk.rejectWithValue(error);
    }
  }
);

export const DeleteSystemAccess = createAsyncThunk(
  "DeleteSystemAccess",
  async ({ data, callback }, thunkAPI) => {
    console.log(data, "data++=++++++++++++++++++++");
    try {
      const response = await del(URL.DELETE_ACCESS + data);
      console.log(data, "data----------->");
      callback && callback(null, response);
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error.message, null);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

